<form id="confirmForm" class="tw-p-2">
  <dialog-header>New Folder</dialog-header>
  <mat-dialog-content>
    <div class="form-group">
      <input
        id="newFolderInput"
        name="folderName"
        type="text"
        class="form-control -tw-mt-6"
        [(ngModel)]="folderName"
        placeholder="Enter Folder Name"
        (focus)="duplicateFolderSpecified=false"
        [focusMe]="{ delay: 250 }"
      >
      <div class="tw-mt-4">
        @if (accessDenied) {
          <div class="alert alert-danger" role="alert">You don’t have permission to do this.</div>
        }
        @if (serverError) {
          <div class="alert alert-danger" role="alert">An error has occured. {{ apiErrorMessage }}</div>
        }
        @if (duplicateFolderSpecified) {
          <div class="alert alert-danger" role="alert">
            A folder with this name already exists in your company. Please enter a different name.
          </div>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-4">
    <button id="newFolderModalCancelButton" type="button" mat-stroked-button (click)="cancel()">
      Cancel
    </button>
    <button id="newFolderModalSaveButton" type="submit" mat-flat-button color="primary" (click)="ok()" [disabled]="!folderName || accessDenied || serverError || waitingForResponse">
      Save
    </button>
  </mat-dialog-actions>
</form>
